module.exports = __webpack_public_path__ + "img/logo_btlab.9a50cbe7.png";